
import { Component, Inject, Prop, Vue } from 'vue-property-decorator';
import { ngtApiEndpoint } from '@/container';
import FileRepository from '@/api/FileRepository';
import ImageAsDataUrlRenderer from '@/ui/ImageAsDataUrlRenderer.vue';

@Component({
    components: {
        ImageAsDataUrlRenderer,
    },
})
export default class GlossMediaDisplay extends Vue {
    @Prop({ type: String, required: true })
    public readonly id!: string;

    @Prop({ type: Boolean, required: false, default: false })
    public readonly upload!: boolean;

    @Inject()
    private fileRepository!: FileRepository;

    public get source(): string {
        if (this.upload) {
            return this.fileRepository.getFileUrl(parseInt(this.id, 10));
        }
        return ngtApiEndpoint + '/media/img/' + this.id;
    }
}
